import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { FilterAttributeOption } from '@df/catalog-ui/listing/filter/filter-attribute-option';
import { FilterAttributeRange } from '@df/catalog-ui/listing/filter/filter-attribute-range';
import { IZippyChangeEvent, IZippyEvent, ZippyEventType, subject } from '@df/legacy/ui/zippy/zippy.abstract';
import { ZippyModule } from '@df/legacy/ui/zippy/zippy.module';
import { Subscription } from 'rxjs';
import { Product } from '../../../catalog/product/product.decorator';
import { ExpandableComponent } from './../../display/expandable/expandable.component';
@Component({
    selector: 'filter-expandable',
    templateUrl: './filter-expandable.html',
    styleUrls: ['./filter-expandable.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ZippyModule]
})
export class FilterExpandableComponent extends ExpandableComponent implements OnInit, OnDestroy {
    @Input()
    filter?: FilterAttributeOption<Product> | FilterAttributeRange<Product>;
    @Input()
    isDefault = false;
    selection = '';
    private subscriptions = new Subscription();
    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private elementRef: ElementRef
    ) {
        super();
    }
    ngOnInit(): void {
        if (this.filter) {
            this.subscriptions.add(this.filter.subscribe(() => this.onFilterUpdate()));
            this.subscriptions.add(subject.subscribe((event: IZippyEvent) => this.onEvent(event)));
        }
        this.onFilterUpdate();
    }
    protected onEvent(event: IZippyEvent | IZippyChangeEvent): void {
        if (!event.stopped) {
            if (event.type === ZippyEventType.open || event.type === ZippyEventType.toggle) {
                if (event.id?.name === this.filter?.id) {
                    setTimeout(() => {
                        this.elementRef.nativeElement.scrollIntoView({ behavior: 'smooth' });
                    }, 250);
                }
            }
        }
    }
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
    get label(): string {
        return this.filter?.attribute?.data?.label || '';
    }
    private onFilterUpdate(): void {
        this.selection = this.getSelection();
        this.changeDetectorRef.detectChanges();
    }
    override get zippyId() {
        return (this.filter && ['filter', this.filter?.id]) || this.defaultId;
    }
    private getSelection(): string {
        if ((this.filter?.filterType === 'attribute-option' || this.filter?.filterType === 'stock') && this.filter?.hasSelection) {
            const filterAttributeOption = this.filter as FilterAttributeOption<Product>;
            const selectedOptions = filterAttributeOption.options.filter(
                i => filterAttributeOption?.selection?.includes(i.value)
            );
            return selectedOptions
                .map(i => i.label?.toString().trim())
                .filter(j => !!j)
                .join(', ');
        }
        return '';
    }
}
